import * as React from 'react';

type DialGaugeProps = {
    segments:number,
    selectedSegments:number;
    color: string;
    widthPx?: number;
}

export function DialGauge(props: DialGaugeProps): JSX.Element {
    const widthPx = props.widthPx || 100;
    const safeWidthPx = Math.min(Math.max(widthPx, 50), 300);
    
    // Each segment is 45 degrees (180 degrees / 4 segments)
    const radius = 16; // Same radius as RadialPieChart for consistency
    const circumference = 2 * Math.PI * radius;
    
    // Calculate the arc length for 180 degrees (half circle)
    const halfCircleLength = circumference / 2;

    const safeSegments = Math.min(Math.max(props.segments, 1), 100);
    const safeSelectedSegments = Math.min(Math.max(props.selectedSegments, 0), safeSegments);
    
    // Each segment length (1/4 of half circle)
    const segmentLength = halfCircleLength / safeSegments;
    
    // Generate segments
    const segments = Array.from({ length: safeSegments }, (_, index) => {
        const segmentIndex = index + 1;
        const isSelected = segmentIndex <= safeSelectedSegments;
        
        // Calculate dash offset to position segment correctly
        // Start from -90 degrees (bottom) and go counter-clockwise
        const offset = -(circumference * 0.25) - (index * segmentLength);
        
        return (
            <path
                key={index}
                style={{
                    stroke: isSelected ? props.color : '#e0e0e0',
                    fill: 'none',
                    strokeWidth: '3.5',
                    strokeLinecap: 'butt',
                    transition: 'stroke 0.3s ease'
                }}
                strokeDasharray={`${segmentLength - 0.5}, ${circumference}`}
                strokeDashoffset={offset}
                d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
            />
        );
    });

    return (
        <div style={{
            display: 'inline-flex',
            width: `${safeWidthPx}px`,
            height: `${safeWidthPx/2}px`,
        }}>
            <svg 
                viewBox="0 18 36 18"
                preserveAspectRatio="none"
                style={{
                    transform: 'rotate(180deg)', // Rotate so dial starts from left
                    display: 'block',
                    width: '100%',
                    height: '100%'
                }}>
                {segments}
            </svg>
        </div>
    );
}
